'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = _interopDefault(require('react'));
var PropTypes = _interopDefault(require('prop-types'));
var styled = _interopDefault(require('styled-components'));
var paths = require('./paths.js');

var Svg = styled.svg.withConfig({
  componentId: "kpecja-0"
})(["width:", ";height:", ";"], function (props) {
  return props.s.width || '5rem';
}, function (props) {
  return props.s.height || 'auto';
});

var FedexLogo = function FedexLogo(_ref) {
  var s = _ref.s,
      className = _ref.className;
  return /*#__PURE__*/React.createElement(Svg, {
    s: s,
    className: className,
    viewBox: "0 0 87 30"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#472F92",
    d: paths.lettersFED
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F47920"
  }, /*#__PURE__*/React.createElement("path", {
    d: paths.letterE
  }), /*#__PURE__*/React.createElement("path", {
    d: paths.letterX
  }), /*#__PURE__*/React.createElement("path", {
    d: paths.registeredMark
  })));
};

FedexLogo.defaultProps = {
  className: null,
  s: {}
};
FedexLogo.propTypes = {
  className: PropTypes.string,
  s: PropTypes.shape({
    width: PropTypes.string,
    height: PropTypes.string
  })
};

exports.default = FedexLogo;
